import './services.settings.css';
import TabBar from '../../../component/tab-bar/tab-bar';
import React, { useState } from 'react';
import { ServicesSettingsPaymentTypes } from './tabs-componenets/services.settings.payment-types';
import { ScholarshipFunders } from './scholarship-funders/scholarship-funders';
import { ServicesSettingsCheckPayment } from './tabs-componenets/check-payment-services/services.settings.check-payment';
import { StandingOrderBankTransferCancelReasonTab } from './standing-order-bank-transfer-cancel-reason/standing-order-bank-transfer-cancel-reason.tab';
import { BouncingCheckReasonsTab } from './bouncing-check-reasons/bouncing-check-reasons.tab';

const tabs = [
  'סוגי שרותים',
  'גופי מימון חיצוניים לסטודנט',
  'עמלה להמחאה חוזרת',
  'הו״ק בנקאיות - סיבות כישלון',
  'סיבות להמחאה שחוזרת',
];

const ServicesSettings = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const onTabSelected = (index: number) => {
    setSelectedIndex(index);
  };

  return (
    <div className={'services-settings-body-page'}>
      <div className={'studies-settings-title'}>הגדרות מערכת - שירותים</div>

      <TabBar
        tabs={tabs}
        onClick={(index) => {
          onTabSelected(index);
          console.log('The index ' + index + 'Is clicked');
        }}
      ></TabBar>
      <br />

      <div style={{ display: selectedIndex === 0 ? 'block' : 'none' }}>
        <ServicesSettingsPaymentTypes />
      </div>
      <div style={{ display: selectedIndex === 1 ? 'block' : 'none' }}>
        <ScholarshipFunders />
      </div>
      <div style={{ display: selectedIndex === 2 ? 'block' : 'none' }}>
        <ServicesSettingsCheckPayment />
      </div>
      <div style={{ display: selectedIndex === 3 ? 'block' : 'none' }}>
        <StandingOrderBankTransferCancelReasonTab />
      </div>
      <div style={{ display: selectedIndex === 4 ? 'block' : 'none' }}>
        <BouncingCheckReasonsTab />
      </div>
    </div>
  );
};

export default ServicesSettings;
